import React from "react";
import { CardHeader } from "@/components/ui/card";
import LocationSelector from "./LocationSelector";
import { CampLocation } from "@/types/campLocation";
import { isWelcomeRouteVisibleWorkflowStatus } from "@/utils/welcomeWorkflowStatus";
import { resolveCampPublicPage } from "@/utils/campPublicUrl";
import { Button } from "@/components/ui/button";
import { ExternalLink, EyeOff } from "lucide-react";
interface LocationEditingHeaderProps {
  location: CampLocation;
  locations: CampLocation[];
  onLocationSelect: (location: CampLocation) => void;
}
const LocationEditingHeader: React.FC<LocationEditingHeaderProps> = ({
  location,
  locations,
  onLocationSelect
}) => {
  const organizationName = location.providedByOrg?.name || "Unknown organization";
  const campPublicPage = resolveCampPublicPage(location.slugPath);
  const campPublicUrl = campPublicPage.kind === "url" ? campPublicPage.url : null;
  return <CardHeader className="border-b">
      <div className="flex justify-between items-center">
        <div className="flex items-center gap-2">
          <h2 className="text-xl font-semibold">
            Editing info for: {location.name}
          </h2>
          {/* Hidden-in-search: not in the /welcome-allowed set (wf_external* or wf_internal30) */}
          {!isWelcomeRouteVisibleWorkflowStatus(location?.workflowStatus) && (
            <span className="inline-flex items-center gap-1 px-2 py-1 rounded-[30px] border text-[12px] leading-tight bg-red-50 text-red-700 border-red-300">
              <EyeOff className="h-3.5 w-3.5" />
              Hidden in search. Contact
              <br />
              support@kidsbooked.com to unhide.
            </span>
          )}
        </div>
        <div className="flex flex-col items-end">
          <Button
            onClick={() => {
              if (!campPublicUrl) return;
              window.open(campPublicUrl, "_blank", "noopener,noreferrer");
            }}
            disabled={!campPublicUrl}
            title={campPublicUrl ?? undefined}
            className="flex items-center gap-2"
          >
            <ExternalLink size={16} className="mr-1" /> View camp page
          </Button>
          {campPublicPage.kind === "none" && (
            <p className="mt-1 max-w-xs text-right text-xs text-red-600">
              This camp location has no page on KidsBooked yet. Contact support@kidsbooked.com to get
              it corrected.
            </p>
          )}
          {campPublicPage.kind === "unknown" && (
            <p className="mt-1 max-w-xs text-right text-xs text-red-600">
              We couldn't determine this camp location's page on KidsBooked. Contact
              support@kidsbooked.com to get it corrected.
            </p>
          )}
        </div>
      </div>
      
      <LocationSelector locations={locations} currentLocationId={location.id} onLocationSelect={onLocationSelect} />
    </CardHeader>;
};
export default LocationEditingHeader;